document.addEventListener('DOMContentLoaded', function () {
  // Snippet injection
  const blogContent = document.querySelector('.blogContent');
  const blogSnippet = document.getElementById('blog-snippet-content');
  const productSnippet = document.getElementById('product-snippet-content');

  if (blogContent) {
    // Replace all occurrences of identifiers with snippet content
    let contentHtml = blogContent.innerHTML;
    if (blogSnippet) {
      contentHtml = contentHtml.replace(/%-single-featured-product-%/g, blogSnippet.innerHTML);
    }
    if (productSnippet) {
      contentHtml = contentHtml.replace(/%-multiple-featured-products-%/g, productSnippet.innerHTML);
    }
    blogContent.innerHTML = contentHtml;
  }

  // Table of Contents generation
  const tocList = document.querySelector('.tocList');
  if (!blogContent || !tocList) return;

  const headings = blogContent.querySelectorAll('h2,h3');
  let currentUl = tocList;
  let currentLi = null;
  let h2Counter = 0;
  let h3Counter = 0;

  headings.forEach((heading, index) => {
    const id =
      heading.innerText
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '') +
      '-' +
      index;
    heading.setAttribute('id', id);

    const a = document.createElement('a');
    a.href = '#' + id;
    a.classList.add('toc-link');

    if (heading.tagName === 'H2') {
      h2Counter++;
      h3Counter = 0; // Reset h3 counter for new h2
      a.textContent = `${h2Counter}. ${heading.textContent}`;
      currentLi = document.createElement('li');
      currentLi.appendChild(a);
      currentUl = tocList; // Reset to main list for h2
      currentUl.appendChild(currentLi);
    } else if (heading.tagName === 'H3' && currentLi) {
      h3Counter++;
      a.textContent = `${h2Counter}.${h3Counter} ${heading.textContent}`;
      let subUl = currentLi.querySelector('ul');
      if (!subUl) {
        subUl = document.createElement('ul');
        subUl.classList.add('toc-sublist');
        currentLi.appendChild(subUl);
      }
      const subLi = document.createElement('li');
      subLi.appendChild(a);
      subUl.appendChild(subLi);
    }
  });

  (function () {
    if (window.innerWidth > 1000) return;
    const tocListItems = tocList.querySelectorAll(':scope > li');
    const { targetLi, isNestedUl } = findTargetLi(tocListItems[1]);
    const sectionNumber = getSectionNumber(targetLi);
    const parentNode = targetLi.parentNode;

    const newNode = createLiElement(`${sectionNumber} ...`, expendElements);
    parentNode.insertBefore(newNode, targetLi);
    const nextSiblings = catchAllSiblingsElement(newNode, isNestedUl);

    toggleElements(nextSiblings, true);

    function findTargetLi(li) {
      const nestedUl = li.querySelector('ul');
      return {
        targetLi: nestedUl ? nestedUl.querySelector('li') : li,
        isNestedUl: !!nestedUl,
      };
    }

    function getSectionNumber(li) {
      let sectionNumber = '...';
      const nextHeadingLink = li.querySelector('a');
      if (nextHeadingLink) {
        const match = nextHeadingLink.textContent.match(/^(\d+(\.\d+)?)/);
        if (match) {
          sectionNumber = match[1];
        }
      }

      return sectionNumber;
    }

    function createLiElement(text, callback) {
      const li = document.createElement('li');
      const button = document.createElement('button');
      button.textContent = text || '';

      if (callback) {
        button.addEventListener('click', () => callback(nextSiblings, newNode));
      }
      li.appendChild(button);

      return li;
    }

    function catchAllSiblingsElement(targetElement, isNestedUl) {
      const siblings = [];

      let next = targetElement.nextElementSibling;
      while (next) {
        siblings.push(next);
        next = next.nextElementSibling;
      }

      if (isNestedUl) {
        let nextNested = targetElement.parentNode.parentNode.nextElementSibling;
        console.log(nextNested);

        while (nextNested) {
          siblings.push(nextNested);
          nextNested = nextNested.nextElementSibling;
        }
      }

      return siblings;
    }

    function toggleElements(elements, isHide) {
      elements.forEach((element) => {
        if (element && element.style) {
          element.style.display = isHide ? 'none' : 'block';
        }
      });
    }

    function expendElements(elements, triggerElement) {
      toggleElements(elements, false);
      if (triggerElement && triggerElement.style) {
        triggerElement.style.display = 'none';
      }
    }
  })();

  // Active link on scroll
  const tocLinks = document.querySelectorAll('.tocList a');

  function onScroll() {
    let scrollPos = window.scrollY || document.documentElement.scrollTop;
    const rootStyles = getComputedStyle(document.documentElement);
    // const announcementBarHeight = parseInt(rootStyles.getPropertyValue('--announcement-bar-height')) || 0;
    const announcementBarHeight = 0;
    const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height')) || 0;
    const offsetAdjustment = announcementBarHeight + headerHeight;

    headings.forEach((heading, index) => {
      const offsetTop = heading.offsetTop - offsetAdjustment;
      const offsetBottom = offsetTop + heading.offsetHeight;

      if (scrollPos >= offsetTop && scrollPos < offsetBottom) {
        tocLinks.forEach((link) => link.classList.remove('active'));
        if (tocLinks[index]) {
          tocLinks[index].classList.add('active');
        }
      }
    });
  }

  window.addEventListener('scroll', onScroll);
});
